import { DataRoomRoute } from '../../models/Route';
import SetupPage from './pages/SetupPage/SetupPage.page';

export default [{ index: true, element: SetupPage }] as Array<DataRoomRoute>;
